module.exports = __webpack_public_path__ + "static/img/title-banner1-type2.e6a57fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/2/title-banner1-type2.png
// module id = LZtX
// module chunks = 1